// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-icon.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-icon-size-xs=1rem] - size of icon
   */
  --sh-icon-size-xs: 1rem;
  /* 
   * @cssprop [--sh-icon-size-s=1.5rem] - size of icon
   */
  --sh-icon-size-s: 1.5rem;
  /* 
   * @cssprop [--sh-icon-size-m=2rem] - size of icon
   */
  --sh-icon-size-m: 2rem;
  /* 
   * @cssprop [--sh-icon-size-l=3rem] - size of icon
   */
  --sh-icon-size-l: 3rem;
  /* 
   * @cssprop [--sh-icon-font-size-xs=1rem] - size of icon image
   */
  --sh-icon-font-size-xs: 1rem;
  /* 
   * @cssprop [--sh-icon-font-size-s=1.5rem] - size of icon image
   */
  --sh-icon-font-size-s: 1.5rem;
  /* 
   * @cssprop [--sh-icon-font-size-m=2rem] - size of icon image
   */
  --sh-icon-font-size-m: 2rem;
  /* 
   * @cssprop [--sh-icon-font-size-l=3rem] - size of icon image
   */
  --sh-icon-font-size-l: 3rem;
  /* 
   * @cssprop [--sh-icon-badge-left=calc(100% - 0.25rem)] - left position the badg will be centered around
   */
  --sh-icon-badge-left: calc(100% - 0.25rem);
  /* 
   * @cssprop [--sh-icon-badge-bottom=calc(100% - 0.25rem)] - bottom position the badg will be centered around
   */
  --sh-icon-badge-bottom: calc(100% - 0.25rem);
}

:host {
  display: flex;
  color: var(--text-primary);
  outline: 0rem;
  position: relative;
  align-items: center;
  font-weight: normal;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga";
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  font-family: "sh-icons";
}
:host > div {
  position: absolute;
  flex: 1;
  transition: var(--transition-time) all ease-in-out;
}
:host > div:after, :host > div:before {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0rem;
  left: 0rem;
}

:host(.item-focused) {
  outline: var(--focus-outline);
  outline-offset: -0.125rem;
}

:host(:not([icon])) {
  display: none;
}

:host([disabled]) {
  pointer-events: none;
  cursor: default;
  opacity: var(--opacity-5);
}

.badge {
  position: absolute;
  z-index: 1;
  bottom: var(--sh-icon-badge-bottom);
  left: var(--sh-icon-badge-left);
  transform: translate(-50%, 50%);
}

.badge[label=""],
.badge[label=""]:not(.number) {
  top: 0rem;
  right: 0rem;
  left: unset;
  transform: none;
}

:host([disabled]) .badge {
  pointer-events: none;
  cursor: default;
}

:host([button]:not([disabled]):not(.accordion-expand)) {
  cursor: pointer;
}
:host([button]:not([disabled]):not(.accordion-expand)) > .first,
:host([button]:not([disabled]):not(.accordion-expand)) > .after {
  opacity: var(--opacity-3);
}

/* hover
 */
:host([button]:hover:not(.no-hovermq)) > .first,
:host([button]:hover:not(.no-hovermq)) > .second,
:host([button].no-hovermq):hover > .first,
:host([button].no-hovermq):hover > .second {
  opacity: var(--opacity-2);
}

/* press (active) */
:host([button].active:not(.no-hovermq)) > .first,
:host([button].active:not(.no-hovermq)) > .second,
:host([button].no-hovermq).active > .first,
:host([button].no-hovermq).active > .second {
  opacity: var(--opacity-3);
}

:host(.badge-width) .badge {
  width: 1.375rem;
}

:host([size=xs]),
:host([size=xs]) > div {
  min-width: var(--sh-icon-font-size-xs);
  min-height: var(--sh-icon-font-size-xs);
  height: var(--sh-icon-font-size-xs);
  width: var(--sh-icon-font-size-xs);
  height: var(--sh-icon-font-size-xs);
  font-size: var(--sh-icon-font-size-xs);
  line-height: var(--sh-icon-font-size-xs);
}

:host([size=xs][button]) {
  min-width: var(--sh-icon-size-xs);
  min-height: var(--sh-icon-size-xs);
  width: var(--sh-icon-size-xs);
  height: var(--sh-icon-size-xs);
}

:host([size=s]),
:host([size=s]) > div {
  min-width: var(--sh-icon-font-size-s);
  min-height: var(--sh-icon-font-size-s);
  height: var(--sh-icon-font-size-s);
  width: var(--sh-icon-font-size-s);
  height: var(--sh-icon-font-size-s);
  font-size: var(--sh-icon-font-size-s);
  line-height: var(--sh-icon-font-size-s);
}

:host([size=s][button]) {
  min-width: var(--sh-icon-size-s);
  min-height: var(--sh-icon-size-s);
  width: var(--sh-icon-size-s);
  height: var(--sh-icon-size-s);
}

:host([size=m]),
:host([size=m]) > div {
  min-width: var(--sh-icon-font-size-m);
  min-height: var(--sh-icon-font-size-m);
  height: var(--sh-icon-font-size-m);
  width: var(--sh-icon-font-size-m);
  height: var(--sh-icon-font-size-m);
  font-size: var(--sh-icon-font-size-m);
  line-height: var(--sh-icon-font-size-m);
}

:host([size=m][button]) {
  min-width: var(--sh-icon-size-m);
  min-height: var(--sh-icon-size-m);
  width: var(--sh-icon-size-m);
  height: var(--sh-icon-size-m);
}

:host([size=l]),
:host([size=l]) > div {
  min-width: var(--sh-icon-font-size-l);
  min-height: var(--sh-icon-font-size-l);
  height: var(--sh-icon-font-size-l);
  width: var(--sh-icon-font-size-l);
  height: var(--sh-icon-font-size-l);
  font-size: var(--sh-icon-font-size-l);
  line-height: var(--sh-icon-font-size-l);
}

:host([size=l][button]) {
  min-width: var(--sh-icon-size-l);
  min-height: var(--sh-icon-size-l);
  width: var(--sh-icon-size-l);
  height: var(--sh-icon-size-l);
}

:host {
  outline: var(--sh-debug-icon-outline-1);
}
:host > div {
  outline: var(--sh-debug-icon-outline-2);
}`;